import "src/decidim/stratified_sortitions/stratum_fields";
import "src/decidim/stratified_sortitions/substratum_fields";
import "chartkick/chart.js";
require.context("../images", true);
import "stylesheets/stratified_sortitions.scss";
